<template>
  <b-modal
    ref="modal"
    title="Từ chối bảo hành"
    id="modal-warranty-rejection"
    @hidden="$emit('hidden')"
  >
    <b-form-group label="Lý do từ chối" label-class="font-weight-bold">
      <b-form-textarea
        :value="value"
        @input="$emit('input', $event)"
        rows="3"
        placeholder="Nhập lý do từ chối..."
      />
    </b-form-group>
    <template #modal-footer>
      <b-button size="sm" variant="secondary" @click="hide">
        Hủy
      </b-button>
      <b-button
        size="sm"
        variant="danger"
        class="font-weight-bolder"
        :disabled="isLoading"
        @click="$emit('submit')"
      >
        <b-spinner v-if="isLoading" small class="mr-1" />
        Xác nhận
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'WarrantyRejectionReasonModal',
  props: {
    value: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>
